import { createSelector } from 'reselect'
import hasUnlockedExtraFreeSamplesCartSelect from 'modules/cart/redux/selectors/has-unlocked-extra-free-samples'
import { shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelector } from 'containers/SpendMoreToUnlockExtraFreeSamples/components/Banner/selectors/should-show'
import { shouldShowUnlockedExtraFreeSamplesBannerCartSelectUtil } from 'containers/UnlockedExtraFreeSamplesBanner/selectors/should-show/utils'
import { isReadyCartSelect } from 'modules/cart/redux/selectors/is-ready'
import isSelectFreeBonusDeluxeSamplesStepGiftSelect from 'modules/gift/redux/selectors/is-select-bonus-deluxe-samples-step'
import shouldShowMinimumToCheckOutBannerCartSelect from 'containers/CartMinimumToCheckOutBanner/selectors/should-show'
import isPostSampleSurveyUrlLocationUtil from 'utils/location/is-post-sample-survey'

const shouldShowUnlockedExtraFreeSamplesBannerCartSelect = createSelector(
  hasUnlockedExtraFreeSamplesCartSelect,
  shouldShowSpendMoreToUnlockExtraFreeSamplesBannerCartSelector(),
  isReadyCartSelect,
  isSelectFreeBonusDeluxeSamplesStepGiftSelect,
  shouldShowMinimumToCheckOutBannerCartSelect,
  (
    hasUnlockedExtraFreeSamples,
    shouldShowSpendMoreToUnlockExtraFreeSamplesBanner,
    isCartReady,
    isSelectFreeBonusDeluxeSamplesStep,
    shouldShowMinimumToCheckOutBanner
  ) => {
    return shouldShowUnlockedExtraFreeSamplesBannerCartSelectUtil({
      hasUnlockedExtraFreeSamples,
      shouldShowSpendMoreToUnlockExtraFreeSamplesBanner,
      isCartReady,
      isSelectFreeBonusDeluxeSamplesStep,
      shouldShowMinimumToCheckOutBanner,
      isPostSampleSurveyUrl: isPostSampleSurveyUrlLocationUtil()
    })
  }
)

export default shouldShowUnlockedExtraFreeSamplesBannerCartSelect
